import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Table } from "primeng/table";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { CountryService } from "../country/service/country.service";
import { StateService } from "../state/service/state.service";
import { CityService } from "../city/service/city.service";
import { CategoryService } from "src/app/services/category.service";
import { AcademyService } from "../academies/service/academies.service";
import { ReportService } from "src/app/services/report.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-academy-enrolment-revenue',
  templateUrl: './academy-enrolment-revenue.component.html',
  styleUrls: ['./academy-enrolment-revenue.component.scss'],
  providers: []
})

export class AcademyEnrolmentRevenueComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  errorMessage = "";
  searchBy: any[];
  totalRecords: 0;
  aerlist: any;
  loading: boolean;
  paginationOption;
  lastTableLazyLoadEvent: LazyLoadEvent;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  downloadaerlist: any;
  searchby;
  public hide: boolean = true;
  @ViewChild("dt", { static: false }) public dt: Table;
  sportList: any;
  countrylist: any[];
  stateList: any[];
  cityList: any[];
  countryCode: string;
  academiesList: any;
  country: any;
  state: any;
  cityName: any;
  sportName: any;
  academyId: any;

  constructor(private countryService: CountryService, private stateService: StateService, private cityService: CityService, private categoryService: CategoryService, private academyService: AcademyService, private reportService: ReportService) {}

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: "Created On", value: "created_at" }
    ];
    this.downloadFlg = false;
    this.getCountries();
    this.getSportList();
    this.getAcademies();
  }

  getAcademies() {
    let query = "?filterByDisable=false&filterByStatus=true";
    this.academyService.getAcademyList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.academiesList = data.data.items;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getSportList() {
    const query = `?filterByDisable=false&getSubcategory=true&pageSize=10&pageNumber=1&filterByParentCategory=Sport`;
    this.categoryService.getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.sportList = data?.data?.items;
    }, err => {
      this.errorMessage = err.error.message;
    })
  }

  getCountries() {
    this.countrylist = [];
    let query = "filterByDisable=false&filterByStatus=true";
    this.countryService.getcountryList(query).pipe(takeUntil(this.destroy$)).subscribe(data => {
        if (data.data.items.length > 0) {
          data.data.items.forEach(element => {
            let countryObj = {
              name: element.name,
              iso2: element.iso2,
            }
            this.countrylist.push(countryObj);
          });
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getStates(event) {
    let countryCode = event.value.iso2;
    this.stateList = [];
    this.cityList = [];
    let query = "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" + countryCode;
    this.stateService.getstateList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach(element => {
          let stateObj = {
            name: element.name,
            id: element.id,
          }
          this.stateList.push(stateObj);
        });
      }
    })
    this.loadAERReports(this.lastTableLazyLoadEvent);
  }

  async getCities(event) {
    const stateCode = event.value.id;
    this.cityList = [];
    let query = "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" + stateCode;
    this.cityService.getcityList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach(element => {
          let cityObj = {
            name: element.name,
            code: element.name,
          }
          this.cityList.push(cityObj);
        });
      }
    })
    this.loadAERReports(this.lastTableLazyLoadEvent);
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.stateList = [];
    this.cityList = [];
    this.country = null;
    this.state = null;
    this.cityName = null;
    this.sportName = null;
    this.academyId = null;
    const resetEvent = Object.assign({}, this.lastTableLazyLoadEvent, { first: 0, filters: {} });
    if (this.dt) {
      this.dt.filters = {};
      this.dt.first = 0;
    }
    this.loadAERReports(resetEvent);
  }

  loadAERReports(event: LazyLoadEvent) {
    event = event || {} as LazyLoadEvent;
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (this.country) {
      params += "&filterByCountries=" + this.country.name;
    }
    if (this.state) {
      params += "&filterByState=" + this.state.name;
    }
    if (this.cityName) {
      params += "&filterByCity=" + this.cityName;
    }
    if (this.sportName) {
      params += "&filterBySportwise=" + this.sportName;
    }
    if (this.academyId) {
      params += "&filterByAcademy=" + this.academyId;
    }
    const getFilterValue = (field) => {
      if (event.filters != undefined && event.filters[field] != undefined && event.filters[field].value !== undefined && event.filters[field].value !== null && event.filters[field].value !== "") {
        return event.filters[field].value;
      }
      return null;
    };
    const columnFilters = [
      { field: "mobileNumber", parameter: "filterByEnrolmentMobileNumber" },
      { field: "username", parameter: "filterByEnrolmentUsername" },
      { field: "enrolmentId", parameter: "filterByEnrolmentId" },
      { field: "enrolmentDate", parameter: "filterByEnrolmentDate" },
      { field: "category", parameter: "filterByEnrolmentCategory" },
      { field: "batch", parameter: "filterByEnrolmentBatch" },
      { field: "age", parameter: "filterByEnrolmentAge" },
      { field: "duration", parameter: "filterByEnrolmentDuration" },
      { field: "academyName", parameter: "filterByEnrolmentAcademyName" },
      { field: "academyState", parameter: "filterByEnrolmentAcademyState" },
      { field: "academyCity", parameter: "filterByEnrolmentAcademyCity" },
      { field: "academyCountry", parameter: "filterByEnrolmentAcademyCountry" },
      { field: "startDate", parameter: "filterByEnrolmentStartDate" },
      { field: "endDate", parameter: "filterByEnrolmentEndDate" },
      { field: "couponApplied", parameter: "filterByEnrolmentCouponApplied" },
      { field: "couponDiscountAmountVenue", parameter: "filterByEnrolmentCouponDiscountVenue" },
      { field: "couponDiscountAmountTPL", parameter: "filterByEnrolmentCouponDiscountTPL" },
      { field: "academyFees", parameter: "filterByEnrolmentAcademyFees" },
      { field: "tplRevenue", parameter: "filterByEnrolmentTplRevenue" },
      { field: "gstAmount", parameter: "filterByEnrolmentGstAmount" },
      { field: "tplCommissionPercent", parameter: "filterByEnrolmentCommissionPercent" },
      { field: "tplCommissionAmount", parameter: "filterByEnrolmentCommissionAmount" },
      { field: "academyPayout", parameter: "filterByEnrolmentAcademyPayout" },
      { field: "tplShare", parameter: "filterByEnrolmentTplShare" },
    ];

    columnFilters.forEach(columnFilter => {
      const value = getFilterValue(columnFilter.field);
      if (value !== null) {
        params += "&" + columnFilter.parameter + "=" + encodeURIComponent(String(value));
      }
    });
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }
    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "ASC";
      } else {
        orderBy = "DESC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.reportService.getAERReport(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data:any) => {
        if (this.downloadFlg === false) {
          this.loading = false;
          this.aerlist = data;
          this.totalRecords = data.totalCount;
        } else {
          this.exportAERReportListData(data);
          this.downloadFlg = false;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadAERReports(this.lastTableLazyLoadEvent);
  }

  async exportAERReportListData(aerReportList) {
    this.downloadaerlist = JSON.parse(JSON.stringify(aerReportList));
    var propertiesRemove = ['message', 'pageNumber', 'pageSize', 'status', 'totalCount', 'totalPages'];
    propertiesRemove.forEach((prop) => {
      delete this.downloadaerlist[prop];
    });

    const summaryHeaders = [
      'Total Number Of Users', 'Total Enrolments Made', 'Total Academies Enrolled',
      'Total Coupon Amount (Venue)', 'Total Coupon Amount (TPL)', 'Total TPL Commission',
      'Total Academy Payout', 'Total TPL Share'
    ];
    const columnHeaders = [
      'Mobile Number', 'Username', 'Enrolment ID', 'Enrolment Date', 'Category', 'Batch', 'Age',
      'Duration', 'Academy Name', 'Academy State', 'Academy City', 'Academy Country', 'Start Date',
      'End Date', 'Coupon Applied', 'Coupon Discount Amount (Venue)', 'Coupon Discount Amount (TPL)',
      'Academy Fees', 'TPL Revenue', 'GST Amount', 'TPL Commission %', 'TPL Commission Amount',
      'Academy Payout', 'TPL Share'
    ];
    const { Workbook } = await import('exceljs');
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('ACADEMY_ENROLMENT_REPORT');

    worksheet.addRow([]);
    const summaryHeaderRow = worksheet.addRow(summaryHeaders);
    summaryHeaderRow.eachCell(cell => {
      cell.font = { bold: true };
    });
    worksheet.addRow([
      this.downloadaerlist.summary.totalNumberOfUsers,
      this.downloadaerlist.summary.totalEnrolmentsMade,
      this.downloadaerlist.summary.totalAcademiesEnrolled,
      this.downloadaerlist.summary.totalCouponAmountVenue,
      this.downloadaerlist.summary.totalCouponAmountTPL,
      this.downloadaerlist.summary.totalTPLCommission,
      this.downloadaerlist.summary.totalAcademyPayout,
      this.downloadaerlist.summary.totalTPLShare,
    ]);
    worksheet.addRow([]);
    const columnHeaderRow = worksheet.addRow(columnHeaders);
    columnHeaderRow.eachCell(cell => {
      cell.font = { bold: true };
    });

    columnHeaders.forEach((header, index) => {
      worksheet.getColumn(index + 1).width = Math.min(Math.max(header.length + 2, 15), 35);
    });

    this.downloadaerlist['data'].forEach((parent: any) => {
      const enrolmentDate = parent.enrolmentDate ? moment(parent.enrolmentDate).format('DD-MM-YYYY') : '';
      const startDate = parent.startDate ? moment(parent.startDate).format('DD-MM-YYYY') : '';
      const endDate = parent.endDate ? moment(parent.endDate).format('DD-MM-YYYY') : '';
      let durationStr = '';
      if (parent.duration == 1 || parent.duration === '1') {
        durationStr = '1 Month';
      } else if (parent.duration > 1 || (typeof parent.duration === 'string' && parseInt(parent.duration) > 1)) {
        durationStr = parent.duration + ' Months';
      }
      const couponAppliedStr = parent.couponApplied || '-';
      const tplCommissionPercentageStr = parent.tplCommissionPercent != null && parent.tplCommissionPercent !== undefined
        ? parent.tplCommissionPercent + ' %'
        : '';

      worksheet.addRow([
        parent.mobileNumber, parent.username, parent.enrolmentId, enrolmentDate, parent.category,
        parent.batch, parent.age, durationStr, parent.academyName, parent.academyState,
        parent.academyCity, parent.academyCountry, startDate, endDate, couponAppliedStr,
        parent.couponDiscountAmountVenue, parent.couponDiscountAmountTPL, parent.academyFees,
        parent.tplRevenue, parent.gstAmount, tplCommissionPercentageStr, parent.tplCommissionAmount,
        parent.academyPayout, parent.tplShare
      ]);
    });

    const excelBuffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([excelBuffer]), 'Academy_Enrolment_Revenue_Report.xlsx');
    this.downloadFlg = false;
  }
   
  addColumns() {
    this.hide = false;
  }
  
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
